// extracted by mini-css-extract-plugin
module.exports = {"table":"Dashboard_table__xJ8Ij"};